import Layout4Main from "components/layout/Layout4Admin";
import { Row, Col, Form, Button, Tab, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Css from './Customer.module.css';
import ApiConection from 'api_ref/ApiConection';
import { useEffect, useState } from "react";
import moment from "moment";
import { AddCommar, ConvertDateTimeToText } from "components/MyControl";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";

export default function PayPendingDetail() {
    const { id } = useParams();
    const api = new ApiConection();

    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingNotApd, setLoadingNotApd] = useState(false);

    const [data, setData] = useState({});
    const [file, setFile] = useState({});
    //ใส่สี
    const getColor = (value) => {
        if (value === null) return ' text-warning';
        if (value === true) return ' text-success';
        if (value === false) return ' text-danger';
    }
    const getQuontation = async () => {
        const response = await api.getData(`api/quontation/${id}`);
        if (response.status === true) {
            setData(response.data);
            //console.log(response.data);
            if (response.data.slip_file_id !== null) {
                getFile(response.data.slip_file_id);
            }
        }
    }

    const handleApproved = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        setLoading(true);

        let data = {
            password: "",
            is_approved: true
        }

        const response = await api.putData(`api/quontation/${id}/audit`, data);
        if (response.status === true);
        getQuontation();

        setLoading(false);
    }

    const handleNotApproved = async (event) => {
        const form = document.querySelector('form')[0];
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoadingNotApd(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoadingNotApd(false);
            return;
        }

        setLoadingNotApd(true);

        let data = {
            password: "",
            is_approved: false
        }

        const response = await api.putData(`api/quontation/${id}/audit`, data);
        if (response.status === true);
        getQuontation();

        setLoadingNotApd(false);
    }

    const getFile = async (file_id) => {
        const response = await api.getData(`api/file/${file_id}`);
        if (response.status === true) {
            setFile(response.data);
        }
    }

    const openFile = (link) => {
        window.open(link, '_blank');
    }

    useEffect(() => {
        getQuontation();
    }, [id])

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Topic}>
                ข้อมูลการขอใช้บริการระบบ DCaaS
            </div>
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <h6>รายละเอียดลูกค้า</h6>

                            </div>
                            <div className={Css.Content}>
                                <Row>
                                    <Col>
                                        <div className="border rounded h-100">
                                            <h6 className={'bg-light border-bottom d-block p-2 ps-3 text-start'}>
                                                บริษัทผู้ขอรับบริการ {data.company_name}
                                            </h6>
                                            <div className=" text-start w-100 m-auto p-4">
                                                <Form noValidate validated={validated} onSubmit={handleApproved} >
                                                    <div >
                                                        <Form.Group as={Row} className="border-bottom">
                                                            <Form.Label column sm={4} className="text-end text-secondary">หมายเลขอ้างอิง</Form.Label>
                                                            <Form.Label column >{data.quontation_number}</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="border-bottom">
                                                            <Form.Label column sm={4} className="text-end text-secondary">สถานะอนุมัติ</Form.Label>
                                                            <Form.Label column className={getColor(data.is_audit)}>{(data.is_audit === null) ? 'รออนุมัติ' : (data.is_audit === true) ? 'อนุมัติ' : 'ไม่อนุมัติ'}</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="border-bottom">
                                                            <Form.Label column sm={4} className="text-end text-secondary">สถานะชำระ</Form.Label>
                                                            <Form.Label column>{(data.payment_status_name === null) ? 'ยังไม่เลือกชำระ' : data.payment_status_name}</Form.Label>
                                                        </Form.Group>

                                                    </div>
                                                    <div className=" mb-1">
                                                        <Form.Group as={Row}>
                                                            <Form.Label column sm={4} className="text-end text-secondary">ช่องทางชำระ</Form.Label>
                                                            <Form.Label column>{data.payment_method_name}</Form.Label>

                                                        </Form.Group>
                                                        <Form.Group as={Row}>
                                                            <Form.Label column sm={4} className="text-end text-secondary">จำนวนที่ชำระ</Form.Label>
                                                            <Form.Label column>{AddCommar(data?.paid_amount?.toFixed(2))}</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="border-bottom">
                                                            <Form.Label column sm={4} className="text-end text-secondary">วันที่ชำระ</Form.Label>
                                                            <Form.Label column>{moment(data.paid_date).format('DD/MM/YYYY HH:mm')}</Form.Label>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="m mb-1">
                                                        <Form.Group as={Row} className="border-botto">
                                                            <Form.Label column sm={4} className="text-end text-secondary">เอกสารแนบ</Form.Label>
                                                            <Col>
                                                                {
                                                                    file.url_preview !== undefined &&
                                                                    <a onClick={event => openFile(file.url_preview)} >
                                                                        <img src={require('images/document-901.png')} width={50} alt='' />
                                                                        <span>{file.file_name}</span>
                                                                    </a>
                                                                }
                                                            </Col>
                                                        </Form.Group>
                                                    </div>
                                                    <div className=" mb-1">
                                                        <Form.Group as={Row} className="border-bottom">
                                                            <Form.Label column sm={4} className="text-end text-secondary">เอกสารที่เกี่ยวข้อง</Form.Label>
                                                            <Col>
                                                                <button type={'button'} className="btn btn-outline-secondary me-1"><i className="fa-regular fa-file"></i> ใบแจ้งหนี้</button>
                                                                <button type={'button'} className="btn btn-outline-secondary"><i className="fa-regular fa-file"></i> ใบเสร็จรับเงิน/ใบกำกับภาษี</button>
                                                            </Col>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="">
                                                        <Form.Group as={Row} className="border-bottom" >
                                                            <Form.Label column sm={4} className="text-end text-secondary">ผู้ขาย/ผู้แนะนำ</Form.Label>
                                                            <Form.Label column ></Form.Label>
                                                        </Form.Group>
                                                    </div>
                                                    {
                                                        alert !== '' &&
                                                        <div className="alert alert-danger" role="alert">
                                                            <div className="text-end">
                                                                <button type="button" className="btn-close" onClick={(event) => setAlert('')}></button>
                                                            </div>

                                                            {alert}
                                                        </div>
                                                    }
                                                    {
                                                        data.is_audit !== true &&
                                                        <div className="text-start mt-5 mb-2">
                                                            <button type={'submit'} className="btn btn-primary me-2 w-33"  >
                                                                {
                                                                    loading === true &&
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                }
                                                                อนุมัติ
                                                            </button>
                                                            <button type={'button'} className="btn btn-secondary w-33" onClick={event => handleNotApproved(event)}>
                                                                {
                                                                    loadingNotApd === true &&
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                }
                                                                ไม่อนุมัติ
                                                            </button>
                                                        </div>
                                                    }

                                                </Form>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="border rounded mb-3">
                                            <h6 className={'bg-light border-bottom d-block p-2 ps-3 text-start'}>
                                                ข้อมูลแพ็คเกจ
                                            </h6>
                                            <div className=" text-start w-100 m-auto d-flex flex-column p-4">
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">แพ็คเกจ</Form.Label>
                                                    <Form.Label column className="text-start">{data.package_master_name_short}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">ประเภทการสมัคร</Form.Label>
                                                    <Form.Label column className="text-start">{data.package_master_period_name}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">ราคา</Form.Label>
                                                    <Form.Label column className="text-start">{AddCommar(data.total)}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">วันที่สมัครใช้บริการ</Form.Label>
                                                    <Form.Label column className="text-start">{ConvertDateTimeToText(data.create_date)}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">วันครบกำหนดชำระ</Form.Label>
                                                    <Form.Label column className="text-start">{ConvertDateTimeToText(data.due_date)}</Form.Label>
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="border rounded ">
                                            <h6 className={'bg-light border-bottom d-block p-2 ps-3 text-start'}>
                                                ข้อมูลในการออกใบเสร็จ/ใบกำกับภาษี
                                            </h6>
                                            <div className=" text-start w-100 m-auto d-flex flex-column p-4">
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">ชื่อ</Form.Label>
                                                    <Form.Label column className="text-start">{data.payment_name}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">ที่อยู่</Form.Label>
                                                    <Form.Label column className="text-start">{data.payment_address}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">หมายเลขโทรศัพท์</Form.Label>
                                                    <Form.Label column className="text-start">{data.payment_tel}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">เลขประจำตัวผู้เสียภาษีอากร</Form.Label>
                                                    <Form.Label column className="text-start">{data.payment_tax_id}</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row}>
                                                    <Form.Label column sm={4} className="text-end text-secondary">สาขา/รหัสสาขา</Form.Label>
                                                    <Form.Label column className="text-start">{data.payment_branch}</Form.Label>
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer4Bottom1 />
        </Layout4Admin1>
    )
}